import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

export interface ClientFinancialStrategiesSharePatchOptions {
  sharedWithClient: boolean;
}

export function clientFinancialStrategiesShareApi(path: string) {
  return {
    path,
    PATCH: (params: ClientFinancialStrategiesSharePatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
